<template>
  <div class="mb-5">
    <v-row class="mb-3 align-center">
      <v-spacer />
      <v-col class="py-3">
        <img
          :src="image(icon)"
          style="width: 80px;"
          alt="icon"
        >
      </v-col>
      <v-spacer />
    </v-row>
    <v-divider />
  </div>
</template>

<script>
  import ServiceIconMixin from '@/components/parts/mixins/ServiceIconMixin'

  export default {
    mixins: [ServiceIconMixin],
    props: {
      icon: {
        type: String,
        default: ''
      }
    }
  }
</script>
